import { apiDelete, apiGet, apiPatch, apiPost } from "./client";
import type {
  ActiveEvent,
  EventDetail,
  EventPatchRequest,
  ExhibitorCreateRequest,
  ExhibitorOut,
  ExhibitorPatchRequest,
  RoomCreateRequest,
  SessionCreateRequest,
  SessionPatchRequest,
} from "@/types/events";

export function getActiveEvent(): Promise<ActiveEvent> {
  return apiGet<ActiveEvent>("/api/eventos/ativo");
}

export interface EventListItem {
  id: number;
  name: string;
}

/** Lista os eventos visíveis (id + nome) — para dropdowns (ex.: cadastro de usuário). */
export function listEvents(): Promise<EventListItem[]> {
  return apiGet<EventListItem[]>("/api/eventos");
}

export function getEvent(eventId: number | string): Promise<EventDetail> {
  return apiGet<EventDetail>(`/api/events/${eventId}`);
}

export function patchEvent(
  eventId: number | string,
  body: EventPatchRequest,
): Promise<EventDetail> {
  return apiPatch<EventDetail>(`/api/events/${eventId}`, body);
}

export function createRoom(eventId: number | string, body: RoomCreateRequest) {
  return apiPost(`/api/events/${eventId}/rooms`, body);
}

export function deleteRoom(eventId: number | string, roomId: number | string) {
  return apiDelete(`/api/events/${eventId}/rooms/${roomId}`);
}

export function createSession(eventId: number | string, body: SessionCreateRequest) {
  return apiPost(`/api/events/${eventId}/sessions`, body);
}

export function patchSession(
  eventId: number | string,
  sessionId: number | string,
  body: SessionPatchRequest,
) {
  return apiPatch(`/api/events/${eventId}/sessions/${sessionId}`, body);
}

export function deleteSession(eventId: number | string, sessionId: number | string) {
  return apiDelete(`/api/events/${eventId}/sessions/${sessionId}`);
}

export function createExhibitor(
  eventId: number | string,
  body: ExhibitorCreateRequest,
): Promise<ExhibitorOut> {
  return apiPost<ExhibitorOut>(`/api/events/${eventId}/exhibitors`, body);
}

export function patchExhibitor(
  eventId: number | string,
  exhibitorId: number | string,
  body: ExhibitorPatchRequest,
) {
  return apiPatch(`/api/events/${eventId}/exhibitors/${exhibitorId}`, body);
}
